import { ElementSettings } from './editor-viewer-element';
import { ElementConditionViewData } from './element-condition';

export class ElementIntegration {
    id: string;
    mimicId: string;
    elementId: string;
    conditionId: string;
    type: ElementIntegrationType;
}

export class ElementIntegrationViewData {
    id: string;
    mimicId: string;
    elementId: string;
    conditionId: string;
    type: ElementIntegrationType;
    elementCondition: ElementConditionViewData;
}

export class ElementIntegrationPreviewData {
    id: string;
    mimicId: string;
    elementId: string;
    conditionId: string;
    type: ElementIntegrationType;
    elementCondition: ElementConditionViewData;
    elementSetting: ElementSettings;
}

export const INTEGRATION_TYPE = {
    STATUS_COLOR: 'STATUS_COLOR',
    VISUAL_STATE: 'VISUAL_STATE',
    NONE: '',
} as const;

export type ElementIntegrationType = (typeof INTEGRATION_TYPE)[keyof typeof INTEGRATION_TYPE];
